import { useSearchParams } from 'react-router-dom';

import { PERIOD_SEARCH_PARAMS } from 'constants/period-jobs-constant';

type useGetViewType = {
  showAssignmentDetails: boolean;
  showJobConfirm: boolean;
  showJobDetails: boolean;
  showList: boolean;
};

const useGetView = (): useGetViewType => {
  const searchParams = useSearchParams()[0];

  const showList =
    !searchParams.get(PERIOD_SEARCH_PARAMS.jobId) &&
    !(searchParams.get(PERIOD_SEARCH_PARAMS.confirmAssignment) === 'true') &&
    !searchParams.get(PERIOD_SEARCH_PARAMS.assignmentDetails);
  const showJobDetails =
    !!searchParams.get(PERIOD_SEARCH_PARAMS.jobId) &&
    !(searchParams.get(PERIOD_SEARCH_PARAMS.confirmAssignment) === 'true') &&
    !searchParams.get(PERIOD_SEARCH_PARAMS.assignmentDetails);
  const showJobConfirm =
    searchParams.get(PERIOD_SEARCH_PARAMS.confirmAssignment) === 'true';
  const showAssignmentDetails =
    !!searchParams.get(PERIOD_SEARCH_PARAMS.jobId) &&
    searchParams.get(PERIOD_SEARCH_PARAMS.assignmentDetails) === 'true';

  return {
    showAssignmentDetails,
    showJobConfirm,
    showJobDetails,
    showList,
  };
};

export default useGetView;
